module.exports = __webpack_public_path__ + "img/ig-icon.46cff07c.svg";